import type { AiSessionStatus } from '../types/template-ai'

/**
 * The query keys of the AI drafts, apart from their hooks: the uploads list writes the drafts counter into this cache
 * too, and importing the hooks from there would close an import cycle.
 */
export const templateAiKeys = {
  all: ['template-ai'] as const,
  detail: (templateId: number) => [...templateAiKeys.all, 'detail', templateId] as const,
  count: (status: AiSessionStatus) => [...templateAiKeys.all, 'count', status] as const,
  sampleFile: (uploadUuid: string | undefined) => [...templateAiKeys.all, 'sample-file', uploadUuid] as const,
}
